import { useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { bootstrapDevice } from "@/lib/bootstrap";
import { syncAnalyticsBootstrapRecord } from "@/lib/posthog";
import { ScrollToTop } from "./components/ScrollToTop";
import { SiteLayout } from "./layout/SiteLayout";
import { AboutPage } from "./pages/AboutPage";
import { DownloadPage } from "./pages/DownloadPage";
import { HomePage } from "./pages/HomePage";
import { KeysPage } from "./pages/KeysPage";
import { LegalPage, legalRoutes } from "./pages/LegalPage";
import { LoginPage } from "./pages/LoginPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { SupportPage } from "./pages/SupportPage";
import { childRoutePath, siteRoutes } from "./routes";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <ScrollToTop />
        <SiteLayout />
      </>
    ),
    children: [
      { index: true, element: <HomePage /> },
      { path: childRoutePath(siteRoutes.download), element: <DownloadPage /> },
      { path: childRoutePath(siteRoutes.login), element: <LoginPage /> },
      { path: childRoutePath(siteRoutes.about), element: <AboutPage /> },
      { path: childRoutePath(siteRoutes.keys), element: <KeysPage /> },
      { path: childRoutePath(siteRoutes.support), element: <SupportPage /> },
      ...legalRoutes.map((route) => ({ path: route.path, element: <LegalPage {...route} /> })),
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);

export default function App() {
  useEffect(() => {
    let cancelled = false;
    void bootstrapDevice({
      platform: "web",
      channel: "site",
      version: import.meta.env.VITE_APP_VERSION ?? "0.0.0",
    }).then((record) => {
      if (!cancelled) {
        syncAnalyticsBootstrapRecord(record);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return <RouterProvider router={router} />;
}
